import { Program, TProgramId, TReportingPeriodTypeId } from '/src/lib/models';
import { DateString, FloatString } from '/src/lib/types';

export type TProgramRecCostId = number;

export interface ProgramRecCost {
  id: TProgramRecCostId;
  created_at: DateString;
  updated_at: DateString;
  program: Program;
  program_id: TProgramId;
  reporting_period_type_id: TReportingPeriodTypeId;
  start_reporting_quarter: DateString;
  end_reporting_quarter: DateString;
  cost: FloatString;
}
